<template>
    <div class="wrapper-form-block-socio-tipo" :inert="pPreview" :class="{'allow-markup-error': markupError}">
        <TrfCheckboxFields
            titulo="Qual o tipo de sócio?"
            :listaDeOpcoes="listagemTiposDeSocios"
            id="form-block-socio-tipos"
            @update:valores-selecionados="(novoValor) => setTiposDeSocios(novoValor)"
            ref="BlockSocioTipo"
        />
        <p class="error-message" v-if="markupError">
            Campo obrigatório!
        </p>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';

  const TIPOS_DE_SOCIO = [
    'isAdministrador',
    'isResponsavelCnpj'
  ]

  export default {
    name: 'TrfBlocoSocioTipo',
    emits: ['update:form-data', 'set:validacao'],
    components: {
        TrfCheckboxFields: defineAsyncComponent(() => import('../../../components/CheckboxFields/index.vue'))
    },
    props: {
        pIsAdministrador: {
            type: Boolean,
            default: false
        },
        pIsResponsavelCnpj: {
            type: Boolean,
            default: false
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        pIsDirty: {
          type: Boolean,
          default: false
        },
        pSocioEmPreenchimento: {
            type: Object,
            default: null
        },
        required: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
        listagemTiposDeSocios: [
          {
            id: "form-block-socio-tipos-administrador",
            label: "Administrador",
            isSelecionada: this.pSocioEmPreenchimento?.socio?.isAdministrador,
            valor: 'isAdministrador'
          },
          {
            id: "form-block-socio-tipos-responsavel-cnpj",
            label: "Responsável CNPJ",
            isSelecionada: this.pSocioEmPreenchimento?.socio?.isResponsavelCnpj,
            valor: 'isResponsavelCnpj'
          }
        ],
        formData: {
            isAdministrador: this.pSocioEmPreenchimento?.socio?.isAdministrador,
            isResponsavelCnpj: this.pSocioEmPreenchimento?.socio?.isResponsavelCnpj
        },
        isDirty: this.pIsDirty
      };
    },
    computed: {
        isInvalida() {
          if (!this.required) return false;
          return this.isDirty && !this.formData.isAdministrador && !this.formData.isResponsavelCnpj
        },
        markupError() {
          return !this.pPreview && this.isInvalida
        }
    },
    watch: {
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
                if(this.required) {
                    this.$emit('set:validacao', !novo);
                }
            }
        },
        pSocioEmPreenchimento: {
          immediate: true,
          handler(novo) {
            if (!novo) return;
            this.formData.isAdministrador = novo.socio.isAdministrador;
            this.formData.isResponsavelCnpj = novo.socio.isResponsavelCnpj;
          },
          deep: true
        }
    },
    methods: {
        setTiposDeSocios(tiposDeSocio) {
            for (const opcao in TIPOS_DE_SOCIO) {
                const key = TIPOS_DE_SOCIO[opcao];
                this.formData[key] = tiposDeSocio.includes(key);
            }
            this.emitFormData(this.formData)
            this.isDirty = true;
        },
        emitFormData(formData = this.formData) {
            this.$emit('update:form-data', formData)
        }
    }
  };
  </script>
  